<template>
  <div class="loading-wrapper">
    <div
      v-if="loading"
      class="spinner-container"
    >
      <vue-simple-spinner
        line-fg-color="#0098C3"
        :size="64"
        :line-size="7"
      />
    </div>
    <div :class="childClass">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    loading: {
      type: Boolean,
    },
    wrapperClass: {
      type: String,
      default: "",
    }
  },
  computed: {
    childClass() {
      return [
        "content-container",
        this.wrapperClass,
        this.loading ? "hide" : ""
      ].filter(v => v.length).join(" ");
    }
  }
};
</script>

<style scoped lang="scss">
.loading-wrapper {
  position: relative;

  > {
    .content-container.hide {
      opacity: 0.5;
      pointer-events: none;
    }

    .spinner-container {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      display: grid;
      place-items: center;
    }
  }
}

</style>
